module.exports = __webpack_public_path__ + "img/mock-player-bar.e869e83e.png";